import BaseSelect from "./base-select";
import {ActionTypeEnum} from "../../base/training-literals";

class GroupSelect extends BaseSelect {
    modelName;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.GROUP_SELECT;
        this.modelName = props.modelName || "";
    }

    init() {
        this.existingGroupId = "-1";
        this.startSelectHandlerId = wv.communicator.addEventListenerWithID(text_startModelSelectionForTimelineLoad, (itemArr) => {
            const operationType = parseInt(itemArr[0]);
            this.actionId = itemArr[1];
            this.userId = itemArr[2];
            this.mapIndex = parseInt(itemArr[3]);
            this.existingGroupId = itemArr[4];

            if (operationType !== SelectionActionApplyToType.Group) {
                return;
            }

            this.startSelection(this.existingGroupId);
        });

        this.cancelSelectHandlerId = wv.communicator.addEventListenerWithID(text_cancelModelSelectionForTimelineLoad, () => {
            this.cancelSelection();
        });
    }

    get(props = {}) {
        return {
            type: this.actionType,
            modelName: props.modelName || this.modelName,
            timelineMap: props.timelineMap || this.timelineMap,
            duration: props.duration || this.until
        }
    }

    startSelection(groupId) {
        clearAllFeaturesFromAllHandler();
        SelectionData.resetHighlight();
        changeSelectionAction(SelectionActionEnum.Highlight);
        SelectionData.changeResetOnOutsideClickState(false);
        GroupTreeController.resetAllHighlight();

        const modelTreeViewList = document.getElementsByClassName('modelTreeView');
        const selectorButtons = document.getElementsByClassName('modelTreeSelectorClass');
        const itemsToShow = [...modelTreeViewList, ...selectorButtons];
        for (let item of itemsToShow) {
            item.style.visibility = 'visible';
        }

        JSTreeManager.hideAllOtherTreeViews();
        ModelTreeControllerFor2D.showModelTree = true;
        JSTreeManager.showModelTreeView('modelTreeViewSideNav', ModelTreeControllerFor2D.showModelTree);
        let items = document.getElementById('modelTreeSelectorChildData');
        items.style.display = 'none';
        JSTreeManager.showFeatureListTreeView('AvailableFileListViewSideNav', false);
        this.hideTreesExcept("groupTreeView");

        if (groupId !== "-1") {
            GroupController.onChangeHighlight(true, [groupId], false);
        }
    }

    sendDataOnSelection({item, enable}) {
        if (this.existingGroupId !== "-1" && this.existingGroupId !== item.id) {
            GroupController.onChangeHighlight(false, [this.existingGroupId], false);
        }

        const payload = {
            message: text_startModelSelectionForTimelineLoad.command,
            actionId: this.actionId,
            index: this.mapIndex,
            actionType: SelectionActionApplyToType.Group,
            item,
            enable,
        };

        wv.communicator.socket.communicateWithContainer(payload);
        if (enable) {
            this.hideTreesExcept();
            ModelTreeControllerFor2D.showModelTree = false;
            JSTreeManager.showModelTreeView('modelTreeViewSideNav', ModelTreeControllerFor2D.showModelTree);
        }
    }

    cancelSelection() {
        this.hideTreesExcept();
        ModelTreeControllerFor2D.showModelTree = false;
        JSTreeManager.showModelTreeView('modelTreeViewSideNav', ModelTreeControllerFor2D.showModelTree);
        SelectionData.resetHighlight();
        GroupTreeController.resetAllHighlight();
    }

    cancel() {
        this.cancelSelection();
        wv.communicator.removeEventListenerWithID(this.startSelectHandlerId);
        wv.communicator.removeEventListenerWithID(this.cancelSelectHandlerId);
        this.startSelectHandlerId = this.cancelSelectHandlerId = null;
    }
}

export default GroupSelect;
